import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private _authService: AuthService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
    return this._check(redirectUrl);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._check('/');
  }

  /*private _check(redirectURL: string): Observable<boolean> {
    return this._authService.check().pipe(
      switchMap(authenticated => {
        if (!authenticated) {
          this._router.navigate(['sign-in'], { queryParams: { redirectURL } });

          return of(false);
        }

        return of(true);
      })
    );
  }*/

  /*private _check(redirectURL: string): Observable<boolean> {
    return this._authService.check().pipe(
      switchMap(authenticated => {
        if (authenticated) {
          return of(true);
        }

        const refreshToken = this._authService.refreshToken;
        if (!refreshToken) {
          return of(false); // Evita redirecionamento imediato
        }

        return this._authService.signInUsingToken().pipe(
          switchMap(success => {
            if (success) {
              return of(true);
            }
            return of(false);
          }),
          catchError(() => of(false))
        );
      })
    );
  }*/

  private _check(redirectURL: string): Observable<boolean> {
    return this._authService.check().pipe(
      switchMap(authenticated => {
        if (authenticated) {
          return of(true);
        }

        const refreshToken = this._authService.refreshToken;
        if (!refreshToken) {
          // ✅ Redireciona imediatamente se não há refresh token
          this._router.navigate(['sign-in'], { queryParams: { redirectURL } });
          return of(false);
        }

        return this._authService.signInUsingToken().pipe(
          switchMap(success => {
            if (success) {
              return of(true);
            }

            // ✅ Redireciona se falhar o refresh
            this._router.navigate(['sign-in'], {
              queryParams: { redirectURL },
            });
            return of(false);
          }),
          catchError(() => {
            this._router.navigate(['sign-in'], {
              queryParams: { redirectURL },
            });
            return of(false);
          })
        );
      })
    );
  }
}
